import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    ruleSet: [],
  },
  getters: {
    ruleSet: (state) => state.ruleSet,
  },
  actions: {
    loadRuleSet(context) {
      return new Promise((resolve, reject) => {
        alice
          .loadRuleSet()
          .then((response) => {
            context.commit('setRuleSetData', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createRuleSet(context, params) {
      const { name } = params;
      return new Promise((resolve, reject) => {
        alice
          .createRuleSet(name)
          .then((response) => {
            context.dispatch('loadRuleSet');
            // console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadRulesBySet(context, params) {
      const { setId } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadRulesBySet(setId)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createRule(context, params) {
      const { setId, data } = params;
      return new Promise((resolve, reject) => {
        alice
          .createRule(setId, data)
          .then((response) => {
            // console.log(response);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveRuleAnswerFromId(context, params) {
      const { ruleId, data } = params;
      return new Promise((resolve, reject) => {
        alice
          .saveRuleAnswerFromId(ruleId, data)
          .then((response) => {
            // console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveRuleKeywordFromId(context, params) {
      const { ruleId, data } = params;
      return new Promise((resolve, reject) => {
        alice
          .saveRuleKeywordFromId(ruleId, data)
          .then((response) => {
            // console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteRuleSet(context, params) {
      const { setId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteRuleSet(setId)
          .then((response) => {
            // console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteRule(context, params) {
      const { ruleId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteRule(ruleId)
          .then((response) => {
            // console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    matchRuleBase(context, params) {
      const {
        setId, text, parent, setName,
      } = params;
      return new Promise((resolve, reject) => {
        alice
          .matchRuleBase(setId, text, parent)
          .then((response) => {
            resolve({
              setId,
              setName,
              data: response.data,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setRuleSetData(state, data) {
      Vue.set(state, 'ruleSet', data);
    },
  },
};
